import {JsonProperty} from './json/json-property';
import {JsonObject} from './json/json-object';

export enum Environment {
  DEBUG = "debug",
  EMULATOR_DEBUG = "emulator_debug", // Emulator with service running locally (yarn run-local)
  EMULATOR_LOCAL = "emulator_local", // Emulator with service running in emulator as well
  EMULATOR_TEST = "emulator_test", // Emulator with TEST service
  DEMO = "demo",
  TEST = "test",
  STAGING = "staging",
  PROD = "prod",
}

export type BaseRequest = {
  memberId?: string,
}

export type BasePrivilegedRequest = BaseRequest & {
  accessToken: string,
}

export type ResponseStatus = {
  code: number,
  text: string,
}

export type BaseResponse = {
  status: ResponseStatus,
  extras?: any,
}

export type ErrorResponse = BaseResponse & {}

export const OK_STATUS: ResponseStatus = {
  code: 200,
  text: "Ok",
}

export const ERROR_STATUS: ResponseStatus = {
  code: 400,
  text: "Invalid request",
}

export const CONFLICT_STATUS: ResponseStatus = {
  code: 409,
  text: "Conflict",
}

export const NOT_FOUND_STATUS: ResponseStatus = {
  code: 404,
  text: "Not found",
}

export const SERVER_ERROR_STATUS: ResponseStatus = {
  code: 500,
  text: "Server error",
}

export function $PROP<T>(name: keyof T): string {
  return name as string;
}

@JsonObject()
export abstract class BaseListItem {

  @JsonProperty()
  id: string;

  @JsonProperty()
  creator: string;

  @JsonProperty()
  created: number;

  protected constructor(id: string, creator?: string, created?: number) {
    this.id = id;
    this.creator = creator;
    this.created = created;
  }

  async onAfterItemDeserialized(): Promise<void> {
  }

  async onBeforeItemSerialized(): Promise<void> {
  }
}